// Media data for Gallery Page and Media Carousel
// Edit this file to update images, videos, and carousel content

export interface GalleryImage {
  id: number;
  src: string;
  alt: string;
}

export interface GalleryVideo {
  id: number;
  src: string;
  title: string;
}

export interface CarouselItem {
  type: 'image' | 'video';
  src: string;
  alt: string;
  text: string;
}

// Gallery Page Images
export const galleryImages: GalleryImage[] = [
  { id: 1, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/g1.jpeg', alt: 'Cleaning services' },
  { id: 2, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/g2.jpeg', alt: 'Cleaning services' },
  { id: 3, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/g3.jpeg', alt: 'Cleaning services' },
  { id: 4, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/g4.jpeg', alt: 'Cleaning services' },
  { id: 5, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/g5.jpeg', alt: 'Cleaning services' },
  { id: 6, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/g6.jpeg', alt: 'Cleaning services' },
  { id: 7, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/g7.jpeg', alt: 'Cleaning services' },
  { id: 8, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A1.jpg', alt: 'Cleaning services' },
  { id: 9, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A2.jpg', alt: 'Cleaning services' },
  { id: 10, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A3.jpg', alt: 'Cleaning services' },
  { id: 11, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A4.jpg', alt: 'Cleaning services' },
  { id: 12, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A5.jpg', alt: 'Cleaning services' },
  { id: 13, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A6.jpg', alt: 'Cleaning services' },
  { id: 14, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A7.jpg', alt: 'Cleaning services' },
  { id: 15, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A8.jpg', alt: 'Cleaning services' },
  { id: 16, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A9.jpg', alt: 'Cleaning services' },
  { id: 17, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A10.jpg', alt: 'Cleaning services' },
  { id: 18, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A11.jpg', alt: 'Cleaning services' },
  { id: 19, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A12.jpg', alt: 'Cleaning services' },
  { id: 20, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A13.jpg', alt: 'Cleaning services' },
  { id: 21, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A14.jpg', alt: 'Cleaning services' },
  { id: 22, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A15.jpg', alt: 'Cleaning services' },
  { id: 23, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A16.jpg', alt: 'Cleaning services' },
  { id: 24, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A17.jpg', alt: 'Cleaning services' },
  { id: 25, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A18.jpg', alt: 'Cleaning services' },
  { id: 26, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A19.jpg', alt: 'Cleaning services' },
  // { id: 27, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A20.jpg', alt: 'Cleaning services' },
  { id: 28, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A21.jpg', alt: 'Cleaning services' },
  { id: 29, src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A22.jpg', alt: 'Cleaning services' },
];

// Gallery Page Videos
export const galleryVideos: GalleryVideo[] = [
  { 
    id: 1, 
    src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/videos/video1.mp4', 
    title: 'Professional Cleaning in Action' 
  },
  { 
    id: 2, 
    src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/videos/video2.mp4', 
    title: 'Deep Cleaning Service' 
  },
  {
    id: 3,
    src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/videos/video3.mp4',
    title: 'Our Team at Work'
  },
];

// Home Page Carousel Items
export const carouselItems: CarouselItem[] = [
  {
    type: 'image',
    src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A22.jpg',
    alt: 'Professional cleaning team at work',
    text: 'Clean spaces are our pride',
  },
  {
    type: 'image',
    src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/g7.jpeg',
    alt: 'Professional cleaning team at work',
    text: 'Transform your space with our professional cleaning services',
  },
  {
    type: 'image',
    src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/g1.jpeg',
    alt: 'Spotless clean home',
    text: 'Experience the joy of a spotless, fresh-smelling home',
  },
  {
    type: 'image',
    src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/g5.jpeg',
    alt: 'Expert cleaning solutions',
    text: 'Expert solutions for homes and commercial spaces',
  },
  {
    type: 'image',
    src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/g2.jpeg',
    alt: 'Expert cleaning solutions',
    text: 'We clean with the depth unseen',
  },
  {
    type: 'image',
    src: 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/c1.png',
    alt: 'Expert cleaning solutions',
    text: 'Our standards are high',
  },

];

// About Page Team Image
export const teamImage = 'https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/gallary/A22.jpg';
